import { SceneSpec } from '../types/reel';

export const BPM = 120;
export const BEAT = 60 / BPM;
export const REEL_DURATION = 21.5;

export const davidPhoto = 'https://cdn.magicpatterns.com/uploads/1LxfewHAEHrdLtkcuDRnj1/DavidDVallejo-Profile-pic.png';

export const isdinScan =
  'https://cdn.magicpatterns.com/patterns/generated-images/149a3345-c917-4da3-83c8-fb031921f8fc.jpg';

/** Every cut lands on the beat (120 BPM · 0.5s per beat · 10 bars). */
export const reelScenes: SceneSpec[] = [
  { id: 'opening', label: 'Who I am', start: 0, end: 5 },
  { id: 'pencil', label: 'Pencil', start: 5, end: 7.5 },
  { id: 'isdin', label: 'ISDIN USA', start: 7.5, end: 9 },
  { id: 'keywords', label: 'Expertise', start: 9, end: 11.5 },
  { id: 'face', label: 'David', start: 11.5, end: 14 },
  { id: 'metrics', label: 'Impact', start: 14, end: 16 },
  { id: 'parkeo', label: 'Parkeo', start: 16, end: 18 },
  { id: 'closing', label: 'Closing', start: 18, end: 21 },
];

/** The last line holds for 2.25s so it can actually be read. */
export const openingLines = [
  { at: 0.25, text: 'I’m David D. Vallejo.' },
  { at: 1.5, text: 'I design AI-native products, end-to-end.' },
  { at: 2.75, text: 'I help you grow revenue and retention.' },
];

export const keywords = [
  'End-to-End Ownership',
  'AI-Native Design',
  'Design Systems',
  'Product Discovery',
  'Cross-functional Leadership',
];

export const metrics = [
  { value: '+20%', label: 'retention' },
  { value: '+15%', label: 'conversion' },
  { value: '+$2.1M', label: 'impact' },
];

/** Parkeo — parking app (from the Product-System Figma file). */
export const parkeoPins = [
  { price: '8€', x: 60, y: 170 },
  { price: '12€', x: 190, y: 140 },
  { price: '18€', x: 110, y: 250 },
  { price: '9€', x: 215, y: 300 },
  { price: '7€', x: 40, y: 360 },
  { price: '15€', x: 170, y: 410 },
  { price: '11€', x: 80, y: 470 },
];

export const parkeoCode = ['3', '4', '6', '1', '5', '2'];

export const parkeoResults = [
  { value: '80%', label: 'Registration completion', from: '60%' },
  { value: '44%', label: 'Conversion to booking', from: '30%' },
  { value: '25s', label: 'Time to register', from: '2 min' },
];
